import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable } from 'rxjs';
import { DeviationApiModel } from 'app/models/deviation-api.model';
import { MwLoadOptionsService } from './utils/load-options.service';
import { MwPayloadModel } from 'app/models/payload.model';
import { MwLoadOptions } from 'app/models/load-options.model';

@Injectable()
export class MwDeviationApiService {
  constructor(
    private http: MwHttpService,
    private loadOptionsService: MwLoadOptionsService
  ) {}

  private apiEndpoint = '/transport/v1/Companies/{companyId}/Deviations';

  getDeviations(
    requestModel?: MwLoadOptions
  ): Observable<MwPayloadModel<DeviationApiModel[]>> {
    let query = requestModel
      ? this.loadOptionsService.buildQuery(requestModel)
      : '';
    query = query.length > 0 ? '?' + query : query;

    return this.http.authGet<MwPayloadModel<DeviationApiModel[]>>(
      `${this.apiEndpoint}${query}`
    );
  }
}
